import React, { useState, useEffect } from 'react';
import styled, { keyframes } from 'styled-components';

const whip = keyframes`
  0% {
    transform: scale(1) rotate(0deg);
  }
  65% {
    transform: scale(1) rotate(100deg);
  }
  85% {
    transform: scale(1.2) rotate(160deg);
  }
  95% {
    transform: scale(1) rotate(240deg);
  }
  100% {
    transform: scale(1) rotate(0deg);
  }
`;

const Container = styled.div<{ $showContainer?: boolean }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  position: relative;
  ${({ $showContainer }) =>
    $showContainer &&
    `
    background: var(--sys-color--secondary-container, rgba(194, 231, 255, 0.16));
    border-radius: 50%;
  `}
`;

const MorphingWrapper = styled.div`
  width: 34px;
  height: 34px;
  position: relative;
  animation: ${whip} 1200ms cubic-bezier(0.4, 0, 0.2, 1) infinite;
`;

const SvgShape = styled.svg<{ $color?: string }>`
  width: 100%;
  height: 100%;
  fill: ${({ $color }) => $color || 'var(--sys-color--primary, #0b57d0)'};
`;

const SHAPES = [
  // Shape 1: Star (8-pointed)
  {
    viewBox: '0 0 33 34',
    path: 'M14.9683 0.839776C15.6732 -0.279924 17.3268 -0.279926 18.0317 0.839775L19.7214 3.52373C20.1848 4.25987 21.1197 4.55915 21.9338 4.23198L24.9021 3.0391C26.1404 2.54145 27.4781 3.49904 27.3804 4.8131L27.1461 7.96297C27.0819 8.82689 27.6597 9.61042 28.5135 9.81717L31.6265 10.571C32.9252 10.8855 33.4362 12.4349 32.5731 13.4414L30.5044 15.854C29.937 16.5158 29.937 17.4842 30.5044 18.146L32.5731 20.5586C33.4362 21.5651 32.9252 23.1145 31.6265 23.429L28.5135 24.1828C27.6597 24.3896 27.0819 25.1731 27.1461 26.037L27.3804 29.1869C27.4781 30.501 26.1404 31.4585 24.9021 30.9609L21.9338 29.768C21.1197 29.4408 20.1848 29.7401 19.7214 30.4763L18.0317 33.1602C17.3268 34.2799 15.6732 34.2799 14.9683 33.1602L13.2786 30.4763C12.8152 29.7401 11.8803 29.4408 11.0662 29.768L8.09794 30.9609C6.85964 31.4585 5.52187 30.501 5.6196 29.1869L5.85388 26.037C5.91814 25.1731 5.34033 24.3896 4.48651 24.1828L1.37348 23.429C0.0747851 23.1145 -0.4362 21.5651 0.426845 20.5586L2.49559 18.146C3.06299 17.4842 3.06299 16.5158 2.49559 15.854L0.426846 13.4414C-0.436199 12.4349 0.074783 10.8855 1.37348 10.571L4.48651 9.81717C5.34033 9.61042 5.91814 8.82689 5.85388 7.96297L5.6196 4.81311C5.52187 3.49904 6.85964 2.54145 8.09794 3.0391L11.0662 4.23198C11.8803 4.55915 12.8152 4.25987 13.2786 3.52373L14.9683 0.839776Z',
  },
  // Shape 2: Gear
  {
    viewBox: '0 0 38 38',
    path: 'M15.3091 3.60363C15.4924 3.454 15.584 3.37919 15.6677 3.31603C17.6389 1.82799 20.3611 1.82799 22.3323 3.31603C22.416 3.37919 22.5076 3.454 22.6909 3.60363C22.7727 3.67042 22.8136 3.70381 22.8541 3.7356C23.7818 4.46445 24.9191 4.87748 26.0993 4.91409C26.1508 4.91569 26.2037 4.91634 26.3094 4.91765C26.5462 4.92059 26.6646 4.92206 26.7694 4.92733C29.2381 5.05162 31.3234 6.79743 31.8747 9.20154C31.8982 9.30358 31.9202 9.41966 31.9642 9.65183C31.9838 9.75547 31.9937 9.80729 32.0042 9.85759C32.2452 11.0109 32.8504 12.0567 33.7309 12.8416C33.7693 12.8759 33.8094 12.9103 33.8895 12.9791C34.069 13.1332 34.1588 13.2102 34.2357 13.2815C36.0467 14.96 36.5194 17.6347 35.393 19.8299C35.3451 19.9231 35.2872 20.0262 35.1714 20.2322C35.1196 20.3242 35.0938 20.3702 35.0694 20.4155C34.5111 21.4536 34.3009 22.6428 34.4697 23.8088C34.4771 23.8597 34.4856 23.9117 34.5027 24.0158C34.5409 24.249 34.56 24.3656 34.573 24.4695C34.879 26.9168 33.5179 29.2689 31.2407 30.2281C31.1441 30.2688 31.0333 30.3106 30.8118 30.3942C30.7129 30.4315 30.6635 30.4501 30.6156 30.4692C29.5192 30.9063 28.592 31.6826 27.9701 32.684C27.943 32.7277 27.916 32.7731 27.862 32.8637C27.741 33.0669 27.6806 33.1685 27.6236 33.2564C26.2814 35.3273 23.7233 36.2563 21.3609 35.5306C21.2606 35.4998 21.1489 35.4608 20.9253 35.3827C20.8256 35.3479 20.7757 35.3305 20.7268 35.3144C19.6052 34.9461 18.3948 34.9461 17.2732 35.3144C17.2243 35.3305 17.1744 35.3479 17.0747 35.3827C16.8511 35.4608 16.7394 35.4998 16.6391 35.5306C14.2767 36.2563 11.7186 35.3273 10.3764 33.2564C10.3194 33.1685 10.259 33.0669 10.138 32.8637C10.084 32.7731 10.057 32.7277 10.0299 32.684C9.40803 31.6826 8.48083 30.9063 7.38436 30.4692C7.33654 30.4501 7.28709 30.4315 7.18821 30.3942C6.96669 30.3106 6.85593 30.2688 6.75928 30.2281C4.48205 29.2689 3.12097 26.9168 3.42698 24.4695C3.43997 24.3656 3.45908 24.249 3.4973 24.0158C3.51436 23.9117 3.52289 23.8597 3.53026 23.8088C3.69906 22.6429 3.48889 21.4536 2.93056 20.4155C2.90621 20.3702 2.88035 20.3242 2.82863 20.2322C2.71278 20.0262 2.65485 19.9231 2.60704 19.8299C1.48057 17.6347 1.95327 14.96 3.76433 13.2815C3.8412 13.2102 3.93096 13.1332 4.11047 12.9791C4.19061 12.9103 4.23068 12.8759 4.26908 12.8416C5.14958 12.0567 5.75476 11.0109 5.99583 9.8576C6.00635 9.80729 6.01617 9.75547 6.03582 9.65183C6.07984 9.41966 6.10185 9.30357 6.12525 9.20154C6.67662 6.79743 8.76192 5.05162 11.2306 4.92733C11.3354 4.92206 11.4538 4.92059 11.6906 4.91765C11.7963 4.91634 11.8492 4.91569 11.9007 4.91409C13.0809 4.87748 14.2182 4.46445 15.1459 3.7356C15.1864 3.70381 15.2273 3.67042 15.3091 3.60363Z',
  },
  // Shape 3: Pentagon
  {
    viewBox: '0 0 28 28',
    path: 'M17.8729 0.620696C23.8872 -1.99138 29.9914 4.11282 27.3793 10.1271L26.9474 11.1214C26.1499 12.9576 26.1499 15.0424 26.9474 16.8786L27.3793 17.8729C29.9914 23.8872 23.8872 29.9914 17.8729 27.3793L16.8786 26.9474C15.0424 26.1499 12.9576 26.1499 11.1214 26.9474L10.1271 27.3793C4.11281 29.9914 -1.99138 23.8872 0.620698 17.8729L1.05257 16.8786C1.85006 15.0424 1.85005 12.9576 1.05257 11.1214L0.620696 10.1271C-1.99138 4.11281 4.11282 -1.99138 10.1271 0.620698L11.1214 1.05257C12.9576 1.85005 15.0424 1.85005 16.8786 1.05257L17.8729 0.620696Z',
  },
  // Shape 4: Oval
  {
    viewBox: '0 0 38 38',
    path: 'M11.9857 7.77706C17.0217 2.74098 25.1869 2.74098 30.2229 7.77706C35.259 12.8131 35.259 20.9783 30.2229 26.0143L26.0143 30.2229C20.9783 35.259 12.8131 35.259 7.77706 30.2229C2.74098 25.1869 2.74098 17.0217 7.77706 11.9857L11.9857 7.77706Z',
  },
  // Shape 5: Clover
  {
    viewBox: '0 0 30 30',
    path: 'M23.1309 23.1309C16.1705 30.0913 6.88765 32.0935 2.39707 27.6029C-2.09352 23.1123 -0.0913343 13.8295 6.86908 6.86908C13.8295 -0.0913329 23.1123 -2.09352 27.6029 2.39707C32.0935 6.88765 30.0913 16.1705 23.1309 23.1309Z',
  },
];

interface LoadingIndicatorProps {
  className?: string;
  showContainer?: boolean;
  color?: string;
}

export const LoadingIndicator = ({
  className,
  showContainer = false,
  color,
}: LoadingIndicatorProps) => {
  const [shapeIndex, setShapeIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setShapeIndex((prev) => (prev + 1) % SHAPES.length);
    }, 1200);

    return () => clearInterval(interval);
  }, []);

  const activeShape = SHAPES[shapeIndex];

  return (
    <Container className={className} $showContainer={showContainer}>
      <MorphingWrapper key={shapeIndex}>
        <SvgShape viewBox={activeShape.viewBox} $color={color}>
          <path d={activeShape.path} />
        </SvgShape>
      </MorphingWrapper>
    </Container>
  );
};

export default LoadingIndicator;
